import React, { FC } from 'react';
import { Text } from 'react-native';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';
import { localTime } from '@helpers';
import { PeriodProps } from '@v2/pages/batch/details/modules/batch/interfaces';

export const Period: FC<PeriodProps> = ({ startedOn, endedOn, additionalTextForStartedTime, C, font: fontProp = font, color = 'Label/Light/Tertiary', fontType = 'Body' }) => {
  const dateTimeFormat = 'D-MMM-YYYY HH:mm';
  const timeFormat = 'HH:mm';

  const isSameDate = endedOn ? localTime(startedOn).isSame(localTime(endedOn), 'day') : false;

  const localStartedOn = localTime(startedOn).format(dateTimeFormat);
  const localEndedOn = endedOn ? localTime(endedOn).format(isSameDate ? timeFormat : dateTimeFormat) : null;

  return (
    <Text numberOfLines={1} style={[fontProp[fontType], { color: C(color) }]}>
      {localStartedOn}
      {additionalTextForStartedTime ? ' ' + i18n.t(additionalTextForStartedTime) : ''}
      {endedOn && ` - ${localEndedOn}`}
    </Text>
  );
};
